import { Navigate } from 'react-router-dom'

import AuthService from '../../utilities/services/auth.service'

import { FundraisersWrapper } from '../../components'

export default function FundraisersPage() {
  const organization = AuthService.getOrg()?.[0]

  if (!organization?.setting?.fundraisingEnabled) {
    return <Navigate to="/settings/organization-information" replace />
  }

  return <FundraisersWrapper />
}
